const defaultQuestions = [
  {
    question_id: 1,
    task_id: null,
    question_text: '您考虑离职的主要原因是什么？',
    question_type: 'multiple_choice',
    options: [
      '薪酬福利不符合预期',
      '工作压力过大，难以平衡生活',
      '个人职业发展空间受限',
      '与上下级或团队关系不和睦',
      '实际工作内容与原本期望严重不符',
      '寻找到了更好的外部职业机会',
      '认为公司整体发展前景不明朗',
      '办公环境不佳或通勤时间过长',
      '家庭原因或其他个人客观原因',
      '其他原因'
    ],
    required: 1,
    sort_order: 1,
    max_select: 3,
    status: 1,
    created_at: '2026-05-01T10:00:00',
    updated_at: '2026-05-01T10:00:00'
  },
  {
    question_id: 2,
    task_id: null,
    question_text: '如果有改善，您是否愿意留下？',
    question_type: 'single_choice',
    options: ['是', '否', '视情况而定'],
    required: 1,
    sort_order: 2,
    max_select: null,
    status: 1,
    created_at: '2026-05-01T10:00:00',
    updated_at: '2026-05-01T10:00:00'
  },
  {
    question_id: 3,
    task_id: null,
    question_text: '对公司与管理者的建议',
    question_type: 'fill_blank',
    options: [],
    required: 0,
    sort_order: 3,
    max_select: null,
    status: 1,
    created_at: '2026-05-01T10:00:00',
    updated_at: '2026-05-01T10:00:00'
  }
]

export function getStoreSurveyQuestions() {
  const s = require('../store').default
  const stored = s.state.surveys && s.state.surveys.questions
  if (stored && stored.length > 0) return stored
  s.commit('SET_SURVEY_QUESTIONS', defaultQuestions)
  return defaultQuestions
}
